.container {
  margin-top: 8px;
  margin-bottom: 8px;
}

.title {
  margin-left: 32px;
}

/* An anchored group in the sidebar Chat draws its own boundary (chat makeover M3) */
.standalone {
  width: 100%;
}
